import React from 'react'
import GlobalStyles from '../../../../components/component-items/styles'
import { TableCell } from '../../../../components/component-items/datatable'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/pro-duotone-svg-icons'
import { LargeButton } from '../../../../components/component-items/buttons'

import type { WarehouseUserRoleAssignment } from '../../../../types/rbac'

// Format date as "Jan 1, 2025"
const formatFriendlyDate = (dateString: string | null) => {
  if (!dateString) return null
  const date = new Date(dateString)
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}

interface RoleAssignmentTableProps {
  assignments: WarehouseUserRoleAssignment[]
  onEdit: (assignment: WarehouseUserRoleAssignment) => void
  onRemove: (assignmentId: number) => void
}

export const RoleAssignmentTable = ({ assignments, onEdit, onRemove }: RoleAssignmentTableProps) => {
  if (assignments.length === 0) {
    return (
      <div
        style={{
          padding: '2em',
          textAlign: 'center',
          background: '#f8f9fa',
          borderRadius: '4px',
          color: '#6c7293',
        }}
      >
        No roles assigned. Click "Assign Role" to add a role.
      </div>
    )
  }

  return (
    <GlobalStyles.DataTable>
      <thead>
        <tr>
          <th>
            <span className="text">Scope</span>
          </th>
          <th>
            <span className="text">Role</span>
          </th>
          <th>
            <span className="text center">Assigned At</span>
          </th>
          <th>
            <span className="text center">Actions</span>
          </th>
        </tr>
      </thead>
      <tbody>
        {assignments.map((assignment) => (
          <tr key={assignment.id}>
            <TableCell
              input={
                assignment.scope_type === 'global' ? (
                  <span style={{ fontWeight: 600 }}>Global (All Warehouses)</span>
                ) : (
                  assignment.warehouse_name || `Warehouse #${assignment.warehouse}`
                )
              }
            />
            <TableCell input={assignment.role_name} />
            <TableCell center input={formatFriendlyDate(assignment.assigned_at)} />
            <TableCell
              center
              input={
                <div className="dropdown__container" style={{ display: 'flex', justifyContent: 'center' }}>
                  <GlobalStyles.Tooltip data-title="Edit">
                    <LargeButton onClick={() => onEdit(assignment)} title="Edit role assignment">
                      <FontAwesomeIcon icon={faEdit} />
                    </LargeButton>
                  </GlobalStyles.Tooltip>
                  <GlobalStyles.Tooltip data-title="Remove">
                    <LargeButton onClick={() => onRemove(assignment.id)} title="Remove role assignment">
                      <FontAwesomeIcon icon={faTrash} style={{ color: '#dc3545' }} />
                    </LargeButton>
                  </GlobalStyles.Tooltip>
                </div>
              }
            />
          </tr>
        ))}
      </tbody>
    </GlobalStyles.DataTable>
  )
}

export default RoleAssignmentTable
